<script>
  import { _ } from 'svelte-i18n';

  export let cssClass = '';
</script>

<div class="cmp-rating__card-second {cssClass}" data-step="3">
  <div class="card-header border-0 mb-0">
    <h2 class="title-medium-2-bold mb-0" id="rating-feedback">
      {$_('thanks')}
    </h2>
  </div>
</div>
